export const getJAccount = state => state.jibestream.account
export const getJBuildings = state => state.jibestream.buildings
export const getJBuilding = state => state.jibestream.building
